export enum LoginProviderEnum {
  Phone = 'Phone',
  Apple = 'Apple',
  Line = 'Line',
}
